import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["connectionStatus", "connectionText", "instanceGrid", "summaryStats"]
  static values = {
    environment: { type: String, default: "production" }
  }

  connect() {
    this.setupActionCable()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  setupActionCable() {
    this.consumer = createConsumer()

    this.subscription = this.consumer.subscriptions.create(
      { channel: "DevopsDashboard::StatusChannel", environment: this.environmentValue },
      {
        connected: () => this.handleConnected(),
        disconnected: () => this.handleDisconnected(),
        received: (data) => this.handleReceived(data)
      }
    )
  }

  handleConnected() {
    this.updateConnectionStatus(true)
    console.log(`[DevopsDashboard] Connected to ${this.environmentValue} channel`)
  }

  handleDisconnected() {
    this.updateConnectionStatus(false)
    console.log("[DevopsDashboard] Disconnected from channel")
  }

  handleReceived(data) {
    if (typeof data === "string" && data.includes("turbo-stream")) {
      Turbo.renderStreamMessage(data)
    }
  }

  updateConnectionStatus(connected) {
    if (this.hasConnectionStatusTarget) {
      this.connectionStatusTarget.classList.toggle("connection-status--connected", connected)
      this.connectionStatusTarget.classList.toggle("connection-status--disconnected", !connected)
    }
    if (this.hasConnectionTextTarget) {
      this.connectionTextTarget.textContent = connected ? "Connected" : "Disconnected"
    }
  }

  environmentValueChanged() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.setupActionCable()
    }
  }

  refresh() {
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
